import { CSSProperties } from "react";

interface Props {
  onClick?: (e: any) => void;
  style?: CSSProperties;
  clasName?: string;
}

const SvgHomeIndicator: React.FC<Props> = ({ onClick, style, clasName }) => {
  return (
    <svg
      style={{ ...style }}
      className={clasName}
      onClick={onClick}
      width="50"
      height="6"
      viewBox="0 0 50 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 0.786133H2C0.89543 0.786133 0 1.81483 0 3.08379C0 4.35275 0.89543 5.38145 2 5.38145H48C49.1046 5.38145 50 4.35275 50 3.08379C50 1.81483 49.1046 0.786133 48 0.786133Z"
        fill="#E7E7E7"
      />
    </svg>
  );
};

export default SvgHomeIndicator;
